import { ExclamationTriangleIcon } from 'assets/icons'
import { ButtonLoading } from 'components/Buttons'
import { Modal, ModalContent, ModalIcon } from 'components/Modal'
import FormattedMessage from 'utils/FormattedMessage'
import { useTranslation } from 'utils'

type Props = {
  open: boolean
  secondLeft: number
  onCancel: () => void
  onConfirm: () => void
}

export const KioskCountdownModal = ({ open, secondLeft, onCancel, onConfirm }: Props) => {
  const intl = useTranslation()

  return (
    <Modal
      open={open}
      onClose={onCancel}
      submitButton={
        <ButtonLoading onClick={onConfirm}>
          <FormattedMessage id='kiosk.backModal.submit' />
        </ButtonLoading>
      }
      cancelButton={
        <ButtonLoading onClick={onCancel}>
          <FormattedMessage id='kiosk.backModal.cancel' />
        </ButtonLoading>
      }
    >
      <ModalIcon
        icon={
          <ExclamationTriangleIcon className='h-6 w-6  stroke-orange-600' aria-hidden='true' />
        }
      />
      <ModalContent
        title={intl({ id: 'kiosk.backModal.title' })}
        description={`${intl({ id: 'kiosk.backModal.description' })} ${secondLeft} ${intl({
          id: 'seconds',
        })}`}
      />
    </Modal>
  )
}
